/**
 * Normaliza el enlace guardado en una notificación a una ruta que el router sepa abrir.
 *
 * El router solo define `path: 'clientes'` —sin hijo `:id`—, así que `/clientes/<uuid>`
 * no matchea ninguna ruta y muestra el 404 de React Router. La ficha se abre con query
 * params sobre la ruta índice: `/clientes?id=<uuid>&ficha=cuenta` (`Clientes.tsx`).
 *
 * Los orígenes escriben la forma que abre la ficha con `rutaFichaCliente`. Esta función
 * traduce las notificaciones ya guardadas con la forma `/clientes/<uuid>`, que conservan su
 * enlace tal como se escribió. La salida es la misma que la del origen, así que una
 * notificación vieja y una nueva del mismo cliente abren lo mismo.
 *
 * No es código de transición y no se borra: el histórico guardado la sigue necesitando.
 */

import { rutaFichaCliente } from '@/lib/ruta-cliente'

const CLIENTE_CON_ID =
  /^\/clientes\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\?(.*))?$/i

export function normalizarEnlaceNotificacion(enlace: string): string {
  const match = CLIENTE_CON_ID.exec(enlace)
  if (!match) return enlace

  const [, clienteId, query] = match
  const origen = new URLSearchParams(query ?? '')

  // La base lo nombra `tab`; la ficha lo lee como `ficha`. `semana` solo sirve para
  // deduplicar del lado del cron, así que no viaja.
  const ficha = origen.get('ficha') ?? origen.get('tab') ?? undefined

  return rutaFichaCliente(clienteId, ficha)
}
